var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;

module.exports = React.createClass({

  getInitialState: function() {
    var btnCollection = null, btn2Collection = null;

    if (this.props.btnText) {
      btnCollection = <Link to={this.props.btnLink} className="btn btn-primary">
                          {this.props.btnText}
                      </Link>;
    }
    if (this.props.btnText) {
      btn2Collection = <Link to={this.props.btn2Link} className="btn btn-primary">
                          {this.props.btn2Text}
                      </Link>;
    }
    return { btnCollection: btnCollection,
             btn2Collection: btn2Collection };
  },

  render: function() {

    return <section ref="root" id="promo-block" className="container">
            <div className="row">
                <div className="col-xs-12">
                    <div className="promo-block-inner">
                        <div className="promo-block-content row">
                            <div className="col-sm-6 img-wrap">
                                <img src={this.props.image}></img>
                            </div>
                            <div className="col-sm-6 text-wrap">
                                <p className="lead">{this.props.prefix}</p>
                                <h1>{this.props.title}</h1>
                                <p>{this.props.text}</p>
                                <div>{this.state.btnCollection}</div>
                                <div>{this.state.btn2Collection}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </section>
  }
});